import { ReactNode } from "react";
import { TaskMarkdown } from "./TaskMarkdown";
import { cn } from "@/lib/utils";
import { Dialog } from "./Dialog";
import { TaskTitle } from "./ChapterCard/TaskContent";

type ReadDialogProps = {
    title?: string;
    text: string;
    trigger?: ReactNode;
    /** See TaskMarkdown.suppressProviderWarnings */
    suppressProviderWarnings?: boolean;
    textColor?: string;
    scrollContainerClass?: string;
    onOpenChange?: (open: boolean) => void;
    open?: boolean;
};
export function ReadDialog({ onOpenChange, open, scrollContainerClass, title, trigger, textColor, suppressProviderWarnings, text }: ReadDialogProps) {
    return <Dialog
        open={open}
        onOpenChange={onOpenChange}
        title={title}
        trigger={trigger}
        titleClass={textColor}
        scrollContainerClass={scrollContainerClass}
    >
        <ReadContent
            text={text}
            suppressProviderWarnings={suppressProviderWarnings}
            textColor={textColor}
        />
    </Dialog>;
}

type ReadContentProps = {
    title?: string;
    text: string;
    /** See TaskMarkdown.suppressProviderWarnings */
    suppressProviderWarnings?: boolean;
    textColor?: string;
};
export function ReadContent({ title, text, suppressProviderWarnings, textColor }: ReadContentProps) {
    return <>
        {title && <TaskTitle title={title} />}
        <TaskMarkdown
            textColor={textColor}
            suppressProviderWarnings={suppressProviderWarnings}
            components={{
                h2(props) {
                    return (
                        <>
                            <br />
                            <h2 className={cn("text-step-current", textColor)} children={props.children} />
                        </>
                    );
                },
                blockquote(props) {
                    return (
                        <blockquote className={cn("pl-8 text-step-current text-lg", textColor)} children={props.children} />
                    );
                }
            }}
        >
            {text || "Lyckades inte hitta texten. Vänligen försök igen senare"}
        </TaskMarkdown>
    </>;
}